// extracted by mini-css-extract-plugin
export default {"container":"TodaysSchedule_container__kYbAH","title":"TodaysSchedule_title__o5odm","body":"TodaysSchedule_body__CeM5J"};